export default __webpack_public_path__ + "static/media/stand_5.e5f43925.jpg";